import type { Policy } from '@cartwhl/common/appletPolicy';

import { withProvider } from './adminUserManagementStore';
import AdminUserManagement from './components/AdminUserManagement';

const AdminUserManagementWithStore = withProvider(AdminUserManagement);

const applet = {
  id: 'admin-user-management',
  path: '/admin-user-management',
  paths: ['/admin-user-management'],
  label: 'Admin User Management',
  description: 'Search and manage users, organizations, and service accounts.',
  dashboard: {
    title: 'Admin User Management',
    description:
      'Search and manage users, organizations, and service accounts.',
    order: 90,
  },
  policy: {
    requiresLoggedIn: true,
    requiresAdmin: true,
  } satisfies Policy,
  component: AdminUserManagementWithStore,
};

export default applet;
